'use client';
import { SceneCode } from '@/apis/recommend/recommend.interface';
import RecommendClient from '@/components/recommend/recommendClient';
import { EXPOSURE_RECORD, sendClickTrack } from '@/tracks/32632';
type Props = {
  initRecommendStore?: any;
  skus: string;
  categoryId: string;
};

export default function RecommendList({ initRecommendStore, skus, categoryId }: Props) {
  return (
    <RecommendClient
      initRecommendStore={initRecommendStore}
      sceneCode={SceneCode.PRODUCT_DETAIL_PAGE}
      mainSkus={skus}
      c3Id={categoryId}
      trackParams={{
        RecomSku_Expo: EXPOSURE_RECORD.Productdetail_RecomSku_Expo,
        RecomSku_Addcart_Expo: EXPOSURE_RECORD.Productdetail_RecomSku_Addcart_Expo,
        productClick: sendClickTrack.Productdetail_RecomSku,
        addCartClick: sendClickTrack.Productdetail_RecomSku_Addcart,
        extraParams: { mainskuid: skus },
      }}
    />
  );
}
